enum SupportedLanguages {
  EN = "en",
  FR = "fr",
}

export default SupportedLanguages;
